export const RG_HISTORY_SET_ERROR = 'RG_HISTORY:SET_ERROR';
export const RG_HISTORY_TOGGLE_LOADING = 'RG_HISTORY:TOGGLE_LOADING';
export const RG_HISTORY_UPDATE_PROPERTY = 'RG_HISTORY:UPDATE_PROPERTY';
export const RG_HISTORY_UPDATE_LIMIT_TYPE = 'RG_HISTORY:UPDATE_LIMIT_TYPE';
export const RG_HISTORY_UPDATE_ENABLED_TYPES = 'RG_HISTORY:UPDATE_ENABLED_TYPES';

export const updateFrom = (from) => ({
    type: RG_HISTORY_UPDATE_PROPERTY,
    payload: {
        name: 'from',
        value: from
    }
});

export const updateLimits = (limits) => ({
    type: RG_HISTORY_UPDATE_PROPERTY,
    payload: {
        name: 'limits',
        value: limits
    }
});

export const updatePeriod = (period) => ({
    type: RG_HISTORY_UPDATE_PROPERTY,
    payload: {
        name: 'period',
        value: period
    }
});

export const updateStartDate = (startDate) => ({
    type: RG_HISTORY_UPDATE_PROPERTY,
    payload: {
        name: 'startDate',
        value: startDate
    }
});

export const updateLimitType = (limitType) => ({
    type: RG_HISTORY_UPDATE_LIMIT_TYPE,
    payload: {
        limitType
    }
});

export const updateEnabledLimitTypes = (enabledLimitTypes) => ({
    type: RG_HISTORY_UPDATE_ENABLED_TYPES,
    payload: {
        enabledLimitTypes
    }
});

export const toggleLoading = (isLoading) => ({
    type: RG_HISTORY_TOGGLE_LOADING,
    payload: isLoading
});

export const setError = (error) => ({
    type: RG_HISTORY_SET_ERROR,
    payload: error
});
